/**
 * Set-password template part entry.
 *
 * Importing the SCSS here makes Vite bundle the part's CSS alongside its JS.
 * Password show/hide toggle plus a client-side "passwords match" check
 * (server-side validation in inc/client-subaccounts.php remains authoritative).
 */

import './index.scss';

const wrappers = document.querySelectorAll('.set-password');

if (wrappers.length) {
	const passwordToggles = document.querySelectorAll('[data-set-password-toggle]');

	passwordToggles.forEach((toggle) => {
		const field = toggle.closest('.set-password__password');
		const input = field?.querySelector('input');

		if (!input) return;

		const showIcon = toggle.querySelector('.set-password__eye-icon--show');
		const hideIcon = toggle.querySelector('.set-password__eye-icon--hide');

		toggle.addEventListener('click', () => {
			const isVisible = input.type === 'text';

			input.type = isVisible ? 'password' : 'text';
			toggle.setAttribute('aria-pressed', String(!isVisible));
			toggle.setAttribute(
				'aria-label',
				isVisible ? toggle.dataset.labelShow : toggle.dataset.labelHide
			);
			showIcon?.toggleAttribute('hidden', !isVisible);
			hideIcon?.toggleAttribute('hidden', isVisible);
		});
	});

	const form = document.querySelector('.set-password__form');
	const password = form?.querySelector('#set_password');
	const passwordConfirm = form?.querySelector('#set_password_2');

	if (password && passwordConfirm) {
		const validateMatch = () => {
			const mismatch = passwordConfirm.value !== password.value;
			passwordConfirm.setCustomValidity(
				mismatch ? passwordConfirm.dataset.mismatchMessage : ''
			);
		};

		password.addEventListener('input', validateMatch);
		passwordConfirm.addEventListener('input', validateMatch);
	}
}
